const CODE_REG_EXP = /^B([0-9]{6})$/;

/** 取引先コードの空き番号を求める（書式に合わないコードは無視する） */
export const getNextBusinessUnitManagementCode = (
  codes: (string | null | undefined)[]
): string => {
  const used = new Set<number>();
  codes.forEach((code) => {
    const matched = code?.match(CODE_REG_EXP);
    if (matched) {
      used.add(Number(matched[1]));
    }
  });

  let next = 1;
  while (used.has(next)) {
    next += 1;
  }
  return `B${String(next).padStart(6, '0')}`;
};
